import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CodeInputModule } from 'angular-code-input';
import { SharedModule } from '../shared';
import { AuthRoutingModule } from './auth-routing.module';
import {
    AccountCreationComponent,
    AccountSetupComponent,
    AccountStepperComponent,
    AccountVerificationComponent,
    AgeComponent,
    LoginComponent,
    PopupComponent,
    PreferredLanguageComponent
} from './components';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { SignoutComponent } from './components/signout/signout.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { AuthInterceptor } from './interceptors';
import { SignInComponent, SignUpComponent } from './pages';

@NgModule({
    declarations: [
        PreferredLanguageComponent,
        AgeComponent,
        AccountSetupComponent,
        AccountVerificationComponent,
        LoginComponent,
        AccountStepperComponent,
        AccountCreationComponent,
        PopupComponent,
        SignUpComponent,
        SignInComponent,
        TermsOfUseComponent,
        PrivacyPolicyComponent,
        SignoutComponent
    ],
    imports: [
        CommonModule,
        AuthRoutingModule,
        SharedModule,
        CdkStepperModule,
        CodeInputModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ]
})
export class AuthModule {}
